<!--
 * @Author: 月魂
 * @Date: 2021-02-02 10:14:49
 * @LastEditTime: 2022-01-31 14:38:45
 * @LastEditors: 月魂
 * @Description: 
 * @FilePath: \bingmayong-ukraine-mobile\src\views\Game.vue
-->
<template>
  <div class="box">
    <Header title="game" />
    <!-- 弹出视频 -->
    <van-overlay v-if="show" :show="show" @click="onClose">
      <div class="wrapper">
        <video
          src="http://image.wearetogether.com.cn/history-fir.mp4"
          poster="http://cdn.topartsintermational.com/game-video-bg-ser.jpg"
          controls
          width="100%"
          style="display: block"
          @click.stop="() => {}"
        ></video>
      </div>
    </van-overlay>
    <audio
      id="audio"
      class="audio"
      loop="loop"
      preload="auto"
      controls="controls"
      src="http://cdn.topartsintermational.com/newYear.mp3"
    ></audio>
    <div class="limit-box">
      <!-- <van-button
        type="danger"
        class="index"
        @click="() => this.$router.push('/')"
        >НАСЛОВНА СТРАНИЦА</van-button
      >
      <van-button
        class="intro-btn"
        type="danger"
        @click="() => (this.introVisible = true)"
        >Увод</van-button
      > -->
      <div class="door" v-show="visible">
        <!-- <img src="http://cdn.topartsintermational.com/door.gif" alt="" /> -->
        <img src="../assets/door.gif" alt="" />
        <video
          :src="src"
          controls
          class="endVideo"
          v-show="showVideo"
          x5-video-player-type="h5"
          playsinline="true"
          webkit-playsinline="true"
        ></video>
      </div>
      <div class="door" v-show="!visible">
        <!-- <img src="http://cdn.topartsintermational.com/door.png" /> -->
        <img src="../assets/door.png" />
        <div class="door-left door-part">
          <!-- 左门 -->
          <draggable
            :forceFallback="true"
            :list="leftBox"
            :options="{ group: 'leftDoor' }"
            @start="leftStart"
            @end="leftEnd"
            class="leftDrag"
            style="width: 100%; height: 100%"
            :move="onLeftMove"
          >
            <img
              v-for="element in leftBox"
              :key="element.id"
              :src="element.url"
              class="door-box"
              height="100%"
            />
          </draggable>
        </div>
        <div class="door-right door-part">
          <!-- 右门 -->
          <draggable
            :forceFallback="true"
            :list="rightBox"
            :options="{ group: 'rightDoor' }"
            @start="rightStart"
            @end="rightEnd"
            class="rightDrag"
            style="width: 100%; height: 100%"
            :move="onRightMove"
          >
            <img
              v-for="element in rightBox"
              :key="element.id"
              class="door-box"
              :src="element.url"
              height="100%"
            />
          </draggable>
        </div>
      </div>
      <div class="list-box">
        <div class="left-list list">
          <div class="title">{{ $t('message.game.leftDoor') }}</div>
          <van-icon
            name="arrow"
            class="scroll-left"
            color="#000"
            size="40"
            @click="scrollToLeft"
          />
          <div class="scr">
            <draggable
              :forceFallback="true"
              :list="leftList"
              :options="{
                group: { name: left, pull: 'clone' },
                filter: '.undraggable',
                sort: false,
              }"
              @end="onLeftEnd"
              :move="onLeftMove"
              class="dragArea"
            >
              <img
                v-show="!element.flag"
                v-for="element in leftList"
                :key="element.id"
                :class="{ undraggable: element.flag }"
                :src="element.url"
                class="left-item list-img"
              />
            </draggable>
          </div>
          <van-icon
            name="arrow-left"
            class="scroll-right"
            color="#000"
            size="40"
            @click="scrollToRight"
          />
        </div>
        <div class="right-list list">
          <div class="title">{{ $t('message.game.rightDoor') }}</div>
          <van-icon
            name="arrow"
            class="scroll-left"
            color="#000"
            size="40"
            @click="scrollToLeft"
          />
          <div class="scr">
            <draggable
              :forceFallback="true"
              :list="rightList"
              :options="{
                group: { name: right, pull: 'clone' },
                filter: '.undraggable',
                sort: false,
              }"
              @end="onRightEnd"
              :move="onRightMove"
              class="dragArea"
            >
              <img
                v-show="!element.flag"
                v-for="element in rightList"
                :key="element.id"
                :class="{ undraggable: element.flag }"
                :src="element.url"
                class="right-item list-img"
              />
            </draggable>
          </div>
          <van-icon
            name="arrow-left"
            class="scroll-right"
            color="#000"
            size="40"
            @click="scrollToRight"
          />
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-menu">
        <div class="left">{{ $t("message.footer.left.title") }}</div>
        <div class="right">
          <div>{{ $t("message.footer.left.item1") }}</div>
          <div>{{ $t("message.footer.left.item2") }}</div>
        </div>
      </div>
      <!-- <div class="footer-menu">
        <div class="left">{{ $t("message.footer.right.title") }}</div>
        <div class="right">{{ $t("message.footer.right.item") }}</div>
      </div> -->
      <div class="footer-menu">
        <div class="left">{{ $t("message.footer.thanks.title") }}</div>
        <div class="right">{{ $t("message.footer.thanks.item") }}</div>
      </div>
      <div class="icon">
        <img src="../assets/qrcode1.jpg" alt="" class="img">
        <img src="../assets/qrcode2.jpg" alt="" class="img">
        <a
          href="https://twitter.com/visitshaanxi"
          target="_blank"
        >
          <img src="../assets/t.png" class="img link" />
        </a>
        <a
          href="https://www.facebook.com/visitshaanxi"
          target="_blank"
        >
          <img src="../assets/f.png" class="img link" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header'
import draggable from 'vuedraggable'
import { shuffle } from '../utils/utils'
export default {
  name: 'Game',
  components: { draggable, Header },
  data () {
    return {
      left: 'leftDoor',
      right: 'rightDoor',
      show: true,
      visible: false,
      dialogVisible: true,
      introVisible: false,
      showVideo: false,
      src: 'http://cdn.topartsintermational.com/end1.mp4',
      leftBox: [],
      leftList: [
        {
          id: 1,
          url: 'http://cdn.topartsintermational.com/door-left1.png',
          code: 1001,
        },
        {
          id: 2,
          url: 'http://cdn.topartsintermational.com/door-left2.png',
          code: 1002,
        },
        {
          id: 3,
          url: 'http://cdn.topartsintermational.com/door-left3.png',
          code: 1003,
        },
        {
          id: 4,
          url: 'http://cdn.topartsintermational.com/door-left4.png',
          code: 1004,
        },
        {
          id: 5,
          url: 'http://cdn.topartsintermational.com/door-left5.png',
          code: 1005,
        },
        {
          id: 6,
          url: 'http://cdn.topartsintermational.com/door-left6.png',
          code: 1006,
        },
        {
          id: 7,
          url: 'http://cdn.topartsintermational.com/door-left7.png',
          code: 1007,
        },
        {
          id: 8,
          url: 'http://cdn.topartsintermational.com/door-left8.png',
          code: 1008,
        },
        {
          id: 9,
          url: 'http://cdn.topartsintermational.com/door-left9.png',
          code: 1009,
        },
        {
          id: 10,
          url: 'http://cdn.topartsintermational.com/door-left10.png',
          code: 10010,
        },
        {
          id: 11,
          url: 'http://cdn.topartsintermational.com/door-left11.png',
          code: 10011,
        },
        {
          id: 12,
          url: 'http://cdn.topartsintermational.com/door-left12.png',
          code: 10012,
        },
        {
          id: 13,
          url: 'http://cdn.topartsintermational.com/door-left13.png',
          code: 10013,
        }
      ],
      rightBox: [],
      rightList: [
        {
          id: 1,
          url: 'http://cdn.topartsintermational.com/door-right1.png',
          code: 1001,
        },
        {
          id: 2,
          url: 'http://cdn.topartsintermational.com/door-right2.png',
          code: 1002,
        },
        {
          id: 3,
          url: 'http://cdn.topartsintermational.com/door-right3.png',
          code: 1003,
        },
        {
          id: 4,
          url: 'http://cdn.topartsintermational.com/door-right4.png',
          code: 1004,
        },
        {
          id: 5,
          url: 'http://cdn.topartsintermational.com/door-right5.png',
          code: 1005,
        },
        {
          id: 6,
          url: 'http://cdn.topartsintermational.com/door-right6.png',
          code: 1006,
        },
        {
          id: 7,
          url: 'http://cdn.topartsintermational.com/door-right7.png',
          code: 1007,
        },
        {
          id: 8,
          url: 'http://cdn.topartsintermational.com/door-right8.png',
          code: 1008,
        },
        {
          id: 9,
          url: 'http://cdn.topartsintermational.com/door-right9.png',
          code: 1009,
        },
        {
          id: 10,
          url: 'http://cdn.topartsintermational.com/door-right10.png',
          code: 10010,
        },
        {
          id: 11,
          url: 'http://cdn.topartsintermational.com/door-right11.png',
          code: 10011,
        },
        {
          id: 12,
          url: 'http://cdn.topartsintermational.com/door-right12.png',
          code: 10012,
        },
        {
          id: 13,
          url: 'http://cdn.topartsintermational.com/door-right13.png',
          code: 10013,
        }
      ],
    }
  },
  mounted () {
    this.leftList = shuffle(this.leftList)
    this.rightList = shuffle(this.rightList)
    const num = Math.ceil(Math.random() * 14)
    this.src = 'http://cdn.topartsintermational.com/end-' + num + '.mp4'
  },
  watch: {
    leftBox: function (val) {
      if (val[0] && val[0].flag && this.rightBox.length === 1) {
        const left = val[0]
        const right = this.rightBox[0]
        if (left.code === right.code) {
          this.visible = true
          // const audio = document.getElementById('audio')
          // audio.pause()
          const video = document.getElementsByClassName('endVideo')
          // video[0].muted = false
          setTimeout(() => {
            this.showVideo = true
            video[0].play()
          }, 1000)
        } else {
          this.$notify({ type: 'danger', message: 'wrong, match failed' })
        }
      }
    },
    rightBox: function (val) {
      if (val[0] && val[0].flag && this.leftBox.length === 1) {
        const left = this.leftBox[0]
        const right = val[0]
        if (left.code === right.code) {
          this.visible = true
          // const audio = document.getElementById('audio')
          // audio.pause()
          const video = document.getElementsByClassName('endVideo')
          // video[0].muted = false
          setTimeout(() => {
            this.showVideo = true
            video[0].play()
          }, 1000)
        } else {
          this.$notify({ type: 'danger', message: 'wrong, match failed' })
        }
      }
    },
    deep: true,
  },
  methods: {
    onClose () {
      const audio = document.getElementById('audio')
      audio.play()
      this.show = false
    },
    // 点击烟花跳转
    handleJump () {
      const num = Math.floor(Math.random() * 6)
      this.$router.push(`/share/${num}`)
    },
    // 列表拖拽结束，此处可以计算index，删除leftlist指定项
    onLeftEnd (ev) {
      if (ev.to.className === 'leftDrag') {
        this.$set(this.leftList[ev.oldIndex], 'flag', true)
      }
    },
    onRightEnd (ev) {
      if (ev.to.className === 'rightDrag') {
        this.$set(this.rightList[ev.oldIndex], 'flag', true)
      }
    },
    leftStart () {
      this.left = ''
    },
    leftEnd () {
      this.left = 'leftDoor'
    },
    rightStart () {
      this.right = ''
    },
    rightEnd () {
      this.right = 'rightDoor'
    },
    // 此处进行列表整合
    onLeftMove () {
      if (this.leftBox.length === 1) {
        const oldId = this.leftBox[0].id
        this.leftBox.pop()
        let q = this.leftList.find((item) => {
          return item.id === oldId
        })
        this.$delete(q, 'flag')
      }
    },
    onRightMove () {
      if (this.rightBox.length === 1) {
        const oldId = this.rightBox[0].id
        this.rightBox.pop()
        let q = this.rightList.find((item) => {
          return item.id === oldId
        })
        this.$delete(q, 'flag')
      }
    },
    scrollToLeft (e) {
      const bro = e.target.nextSibling
      const step = 50
      const max = bro.scrollWidth
      if (bro.scrollLeft < max) {
        bro.scrollLeft += step
      }
    },
    scrollToRight (e) {
      const bro = e.target.previousSibling
      const step = 50
      const min = 0
      if (bro.scrollLeft > min) {
        bro.scrollLeft -= step
      }
    },
  }
}
</script>

<style scoped lang="less">
.box {
  width: 100%;
  min-height: 100vh;
  background: url("http://cdn.topartsintermational.com/gameBg.jpg") no-repeat;
  background-size: cover;
  overflow: hidden;
  .limit-box {
    position: relative;
    margin: auto;
  }
  .audio {
    display: none;
  }
  .intro-btn {
    position: absolute;
    top: 10%;
    right: 0;
    color: #fff;
    font-size: 32px;
    background-color: #ca3540;
    z-index: 1;
  }
  .index {
    position: absolute;
    top: 10%;
    left: 0;
    color: #fff;
    font-size: 32px;
    background-color: #ca3540;
    z-index: 1;
  }
  .door {
    position: relative;
    padding-top: 16px;
    .endVideo {
      width: 198px;
      height: 140px;
      position: absolute;
      top: 106px;
      left: 90px;
      background: #000;
    }
    img {
      display: block;
      margin: auto;
      width: 100%;
    }
    .door-part {
      width: 70px;
      height: 100px;
      border: 1px solid #fff;
      background-color: red;
      position: absolute;
      .door-box {
        width: 100%;
        height: 100%;
      }
    }
    .door-left {
      top: 50%;
      left: 28%;
    }
    .door-right {
      top: 50%;
      right: 28%;
    }
  }
  .list-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    color: #fff;
    padding-bottom: 48px;
    margin: 16px auto 0;
    .list {
      width: 90%;
      overflow: hidden;
      position: relative;
      .scroll-left {
        position: absolute;
        top: 50%;
        left: 0;
        font-weight: bolder;
        transform: translate(0, -50%);
      }
      .scroll-right {
        position: absolute;
        top: 50%;
        right: 0;
        font-weight: bolder;
        transform: translate(0, -50%);
      }
      .scr {
        overflow-x: auto;
        overflow-y: hidden;
        padding-bottom: 3px;
        &::-webkit-scrollbar {
          -webkit-appearance: none;
          width: 6px;
          height: 8px;
        }
        &::-webkit-scrollbar-track {
          border-radius: 3px;
          background: rgb(248 212 180);
          box-shadow: inset 0 0 5px rgb(248 212 180);
          -webkit-box-shadow: inset 0 0 5px rgb(248 212 180);
        }
        /* 滚动条滑块 */
        &::-webkit-scrollbar-thumb {
          border-radius: 3px;
          background: rgb(202, 127, 127);
          box-shadow: inset 0 0 10px rgb(234 181 131);
          -webkit-box-shadow: inset 0 0 10px rgb(234 181 131);
        }
        .dragArea {
          display: inline-block;
          white-space: nowrap;
          height: 120px;
          img {
            width: 80px;
            height: 100%;
          }
          .list-img {
            height: 100%;
            cursor: pointer;
          }
        }
      }
    }
  }
  .introBox {
    min-height: 500px;
    background-color: rgba(92, 1, 8, 0.8);
    h1 {
      color: #fff;
      margin: 0;
      text-align: center;
      line-height: 3;
    }
    p {
      color: #fff;
      margin: 0;
      text-indent: 1em;
      line-height: 2;
      font-size: 18px;
      padding: 0 8px;
    }
  }
  .footer {
  padding: 16px 10px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .icon {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
    .img {
      display: block;
      width: 60px;
      margin-right: 16px;
    }
    .link {
      width: 30px;
    }
  }
  .footer-menu {
    width: 100%;
    color: #fff;
    padding-left: 16px;
    display: flex;
    .left {
      line-height: 1.5;
      margin-right: 6px;
    }
    .right {
      display: flex;
      flex-wrap: wrap;
      line-height: 1.5;
      div {
        width: 100%;
      }
    }
    p {
      margin: 0;
      padding: 0;
      line-height: 24px;
      font-size: 14px;
      font-weight: 500;
    }
  }
}
}
.undraggable {
  background-color: red;
}
</style>
